import { store } from "@/store";
import { DateTime as TimeFormatter } from "luxon";
import sha1 from "js-sha1";

export const placeStore = {
  namespaced: true,
  state: () => ({
    all: "",
    lastTen: "",
    type: "place",
    defaultPlace: {
      _id: new Date().toISOString(),
      type: "place",
      is_synced: false,
      is_default: true,
      extra: "This a default place saved for you",
      name: "Home",
      hash: sha1(new Date().toISOString() + Math.random()),
      saved_at: TimeFormatter.fromISO(new Date().toISOString()).toFormat(
        "y-MM-dd H:m:s"
      )
    },
    actionSuccessMsg: "",
    actionErrorMsg: ""
  }),
  getters: {
    checkIfPlaceWasAdded(state) {
      return state.all.length <= 1;
    },
    getAllPlaces(state) {
      let places = {};
      try {
        state.all.map(item => {
          places[item._id] = item.name;
        });
      } catch (e) {
        return places;
      }

      return places;
    },
    getDefaultPlacesList(state) {
      let res = [];
      try {
        state.all.map(item => {
          if (item.is_default) {
            // console.log(item);
            res.push(item);
          }
        });
      } catch (e) {
        return res;
      }
      return res;
    },
    getDefaultPlace() {
      let defaultPlace = store.getters["place/getDefaultPlacesList"];
      return defaultPlace.pop();
    }
  },
  mutations: {
    getAllPlaces(state) {
      store.state.database
        .find({
          selector: {
            $and: [
              {
                type: "place",
                _id: { $exists: true },
                $or: [{ status: { $exists: false } }, { status: 0 }]
              }
            ]
          },
          sort: ["_id"]
        })
        .then(result => {
          state.all = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    getLastTenRecords(state, root) {
      root.database
        .find({
          selector: { type: state.type, _id: { $exists: true } },
          sort: ["_id"],
          limit: 10
        })
        .then(result => {
          state.lastTen = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    //save records
    save(state, formData) {
      store.state.database.put(formData, function callback(err) {
        if (err) {
          state.actionErrorMsg = "failedSave";
          //console.log("saving failed");
          return false;
        }
        store.commit("place/getAllPlaces");
        state.actionSuccessMsg = "successSave";
      });
    },

    clearMes(state) {
      setTimeout(() => {
        state.actionSuccessMsg = "";
        state.actionErrorMsg = "";
      }, 2000);
      return true;
    },

    getTripByPlace(state) {
      store.state.database
        .find({
          selector: {
            $and: [
              {
                type: "trip",

                _id: { $exists: true },
                $or: [{ status: { $exists: false } }, { status: 0 }]
              }
            ]
          },
          sort: ["_id"]
        })
        .then(result => {
          state.all = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    //delete record from Pouch
    markForDeletion(state, place) {
      store.commit("place/save", place);
    }
  },
  actions: {
    getPlacesAction({ commit }) {
      commit("getAllPlaces");
    },

    getLastTenAction({ commit, rootState }) {
      commit("getLastTenRecords", rootState);
    }
  }
};
